export const SwitchProductionModal: string = 'SwitchProductionModal';
